import { OccCatalogParams, SuccessActionPayload } from '@catalog/const/v2';
import { Action } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { CATALOG, CatalogData } from '../catalog-state';

export const LOAD_CATALOG = '[Catalog] Catalog Load';
export const LOAD_CATALOG_SUCCESS = '[Catalog] Catalog Load Success';
export const LOAD_CATALOG_FAIL = '[Catalog] Catalog Load Fail';
export const CATALOG_SET_STATE = '[Catalog] Catalog Set State';
export const CATALOG_CLEAR_STATE = '[Catalog] Catalog Clear State';

export class CatalogLoad extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_CATALOG;

  constructor(public payload: OccCatalogParams) {
    super(CATALOG);
  }
}

export class CatalogLoadFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_CATALOG_FAIL;

  constructor(public payload: any) {
    super(CATALOG, payload);
  }
}

export class CatalogLoadSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_CATALOG_SUCCESS;

  constructor(public payload: SuccessActionPayload) {
    super(CATALOG);
  }
}

export class CatalogSetState implements Action {
  readonly type = CATALOG_SET_STATE;

  constructor(public payload: CatalogData) {}
}

export class CatalogClearState implements Action {
  readonly type = CATALOG_CLEAR_STATE;
}

export type CatalogLoadAction = CatalogLoad | CatalogLoadFail | CatalogLoadSuccess;
